<template>
<div class="chapter">
<div class="inner_page">
<p class="tx"><br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/></p>
<p class="ct1" id="d7e90615"><a href="#/Text/Brue_ISBN9781936070282_epub_con6_r1#d7e2698" id="d14e522"><b>PART I</b></a><br/>
<a href="#/Text/Brue_ISBN9781936070282_epub_con6_r1#d7e2698" id="d14e526"><i>T<span class="small">HE</span> I<span class="small">NSIDE</span> J<span class="small">OB</span></i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brue_ISBN9781936070282_epub_c8_r1.vue?68c90f98